import Types from '../types'

const initialState = {
    allAftList: [],
    orgUnits: [],
    allAftAccountNames: []
};

export default function aftReducer(state = initialState, action) {
    switch (action.type) {
        case Types.ALL_AFT:
            return {
                ...state,
                allAftList: action.payload
            };
        case Types.ORGANIZATIONAL_UNITS:
            return {
                ...state,
                orgUnits: action.payload
            };
        case Types.ALL_AFT_ACCOUNT_NAMES:
            return {
                ...state,
                allAftAccountNames: action.payload
            };
        default:
            return state;
    }
}
